// The press page's form composes an email instead of posting anywhere: the
// landing has no backend, and a mail client gives the journalist a thread
// with their own address on it. Pure, so it is unit-tested; main.ts wires it.

export type PressInquiry = { to: string; brand: string; email: string; subject: string; message: string }

/** `mailto:` URL for one inquiry. The sender's address goes into the body, since the client sends from whatever account it has. */
export function pressMailto({ to, brand, email, subject, message }: PressInquiry): string {
  const tag = brand ? `[${brand} press] ` : ''
  const body = `${message.trim()}\n\n— ${email.trim()}`
  return `mailto:${to}?subject=${encodeURIComponent(tag + subject.trim())}&body=${encodeURIComponent(body)}`
}
